var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsString, MaxLength } from 'class-validator';
/**
 * How long an evidence reference may be (#1616).
 *
 * ⚠ **One number for input validation, aggregate and column.** If it stood in
 * three places, the input would accept what the column truncates — and a
 * truncated piece of evidence is no evidence.
 */
export const IDENTITY_VERIFICATION_REFERENCE_MAX_LENGTH = 500;
/**
 * The method an identity is checked under today (#1616).
 *
 * ⚠ **A placeholder, and it is called one.** Until TM-9638 has decided on KYC
 * there is no method, but a Versand operator who has seen a piece of evidence
 * and referred to it. The value stands in the column so that every row can
 * later answer whether it came into being before or after the decision.
 *
 * ⚠ **A constant, not an enum.** Which methods there will be is the decision
 * still outstanding; an enum would be the claim that the list is already known.
 * It stands here and not in the aggregate, because the fixture endpoint has to
 * write the same value and `test` may not reach into `pvs-billing`.
 */
export const IDENTITY_VERIFICATION_METHOD_PLACEHOLDER = 'PLACEHOLDER_UNTIL_KYC';
/**
 * An open identity check as the Versand operator sees it in their list (#1616).
 *
 * ⚠ **Only these fields.** The operator works at Therame, not in the practice:
 * they have no patient relationship and no billing relationship. The list
 * therefore carries exactly what makes a practice identifiable over the phone,
 * and nothing else. A spec nails the key set down, so that a later field is a
 * decision and not an oversight.
 *
 * ⚠ **No practice name beside the Standort name.** `pt_office` has no name
 * column; a practice's name stands on its Standort. The town stands beside it,
 * because two Standorte may carry the same name.
 */
export class VersandIdentityCheckDto {
    abrechnungsbeauftragungId;
    /** The Standort's name — in this data model the practice's name. */
    officeLocationName;
    town;
    /** The name as it stood on the account at the moment of the first acceptance. */
    acceptedByName;
    /** This record's earliest acceptance. ISO 8601. */
    firstAcceptedAt;
    /** First covered day, inclusive. `YYYY-MM-DD`. */
    effectiveFrom;
}
/**
 * Body of `POST /v1/versand/identity-checks/:abrechnungsbeauftragungId`
 * (#1616).
 *
 * ⚠ **A placeholder until the KYC decision (TM-9638).** A free reference to what
 * the Versand operator saw — a ticket number, a filing location. Which methods
 * there will be and which fields they bring along is the decision still
 * outstanding; until then a text field stands here and is called one.
 */
export class RecordIdentityVerificationDto {
    reference;
}
__decorate([
    IsString(),
    IsNotEmpty({ message: 'The reference must not be empty.' }),
    MaxLength(IDENTITY_VERIFICATION_REFERENCE_MAX_LENGTH, {
        message: `The reference must be at most ${IDENTITY_VERIFICATION_REFERENCE_MAX_LENGTH} characters.`,
    }),
    __metadata("design:type", String)
], RecordIdentityVerificationDto.prototype, "reference", void 0);
//# sourceMappingURL=versand-identity-check.dto.js.map